module.exports = __webpack_public_path__ + "static/img/zm.6a6942fb.png";